var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button } from "../Button";
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Body.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-popup-message__body" },
            React.createElement("div", { className: "rj-popup-message__body-content" },
                this.props.html && React.createElement("div", { className: "rj-popup-message__body-html", "data-uat": "popup-message", dangerouslySetInnerHTML: { __html: this.props.html } }),
                this.props.children,
                React.createElement("div", { className: "rj-popup-message__body-buttons", "data-uat": "popup-message-body-buttons" }, Object.keys(this.props.actions).map(function (buttonKey, i) { return (React.createElement(Button, __assign({ key: buttonKey + "-" + i, uat: "button-popup-message-" + buttonKey }, _this.props.actions[buttonKey]))); })))));
    };
    return Body;
}(React.Component));
export { Body };
//# sourceMappingURL=Body.js.map